import { render, staticRenderFns } from "./defectManage.vue?vue&type=template&id=1205c5fe"
import script from "./defectManage.vue?vue&type=script&lang=js"
export * from "./defectManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1205c5fe')) {
      api.createRecord('1205c5fe', component.options)
    } else {
      api.reload('1205c5fe', component.options)
    }
    module.hot.accept("./defectManage.vue?vue&type=template&id=1205c5fe", function () {
      api.rerender('1205c5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/defect/defectManage.vue"
export default component.exports